<script>
import { mapState } from 'vuex';

export default {
  name: 'Snackbar',

  computed: {
    ...mapState('ui', ['snack']),

    timeout() {
      const { keepOpen, quick } = this.snack;
      if (keepOpen) {
        return 0;
      }
      if (quick) {
        return 2500;
      }
      return 5000;
    },
  },

  methods: {
    handleActionClick() {
      const { snack, $store } = this;
      snack.handler();
      $store.dispatch('ui/updateSnack', {});
    },

    clearSnack(isVisible) {
      if (!isVisible) {
        this.$store.dispatch('ui/updateSnack', {});
      }
    },
  },
};
</script>

<template>
  <v-snackbar :value="snack.text" :timeout="timeout" @input="clearSnack">
    {{ snack.text }}
    <template v-slot:action="{ attrs }">
      <v-btn
        v-if="snack.actionText"
        color="primary"
        text
        class="snack-action"
        v-bind="attrs"
        @click="handleActionClick"
      >
        {{ snack.actionText }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style lang="scss">
// .v-snack--bottom {
//   left: 32px !important;
//   right: 32px !important;
//   bottom: 36px !important;
// }

// .v-snack__wrapper {
//   background-color: var(--v-secondary-base) !important;
// }

.v-snack__content .v-btn--text {
  text-transform: uppercase;
}

// @media only screen and (min-width: 340px) {
//   .v-snack__wrapper {
//     min-width: 280px !important;
//     width: 100%;
//     max-width: 672px;
//   }
// }
</style>
